import { ApiErrors, ApiErrorsCodes } from 'constants/actionMessages'
import { ApiError, ApiTypingErrors } from 'packages/api'

export const apiTypingErrors = new ApiTypingErrors<ApiError>({
  notValidStatus: 400,
  initialError: {
    message: ApiErrors.UnknownError,
    code: ApiErrorsCodes.UnknownError,
  },
  notFoundError: {
    message: ApiErrors.NotFound,
    code: ApiErrorsCodes.NotFound,
  },
  notValidError: {
    message: ApiErrors.NotValid,
    code: ApiErrorsCodes.NotValid,
  },
  validationReplaceToCamelCase: true,
})

export const { createApi, errorInterceptor, createApiError } = apiTypingErrors
